import React, { useState, useEffect } from 'react'
import { useFormContext } from 'react-hook-form';
import { components, DataFlattener, constants, useTranslation, useServices } from 'cng-web-lib'
import { Card, CardContent, Grid, Chip, Box, Button } from '@material-ui/core'
import Namespace from 'src/constants/locale/Namespace'
import OnBoardWhiteLabelPartyKeys from 'src/constants/locale/key/OnBoardWhiteLabelParty'
import OnBoardWhiteLabelPartyApiUrls from 'src/apiUrls/OnBoardWhiteLabelPartyApiUrls'
import makeValidationSchema from './MakeValidationSchema'
import CngBackdrop from 'src/components/cngcomponents/CngBackDrop';
import { v4 as uuid } from 'uuid'
import TprPartyAutoCompleteField from 'src/components/na/autocomplete/codemaintenance/TprPartyAutoCompleteField'
import CheckboxButton from 'src/components/button/CheckboxButton'

const {
  card: { CngSimpleCardHeader },
  form: {
    field: {
      CngTextField,
      CngCodeMasterAutocompleteField
    }
  },
  table: {
    useFetchCodeMaintenanceLookup
  },
  CngGridItem,
} = components

const { filter: { EQUAL } } = constants

const DEFAULT_INITIAL_VALUES = Object.freeze({
  partyId: '',
  parentPartyId: '',
  requesterName: '',
  declaration1: false,
  declaration2: false,
  declaration3: false,
  declaration4: false,
  declaration5: false,
  declaration6: false
})

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES },
  makeValidationSchema: makeValidationSchema
}

function Fields({ disabled, showNotification, shouldHideMap }) {

  const { translate } = useTranslation(Namespace.ON_BOARD_WHITE_LABEL_PARTY)
  const translatedTextsObject = makeTranslatedTextsObject()
  const { setValue, getValues, reset, watch, trigger } = useFormContext();
  const { securedSendRequest } = useServices()
  const fetchCodeMaintenanceLookup = useFetchCodeMaintenanceLookup()

  const [loadingState, setLoadingState] = useState(false);
  const [upsPartyId, setUPSPartyId] = useState(null);
  const [bandChargeId, setBandChargeId] = useState(null);

  const parentPartyId = watch("parentPartyId")
  const declaration1 = watch("declaration1")
  const declaration2 = watch("declaration2")
  const declaration3 = watch("declaration3")
  const declaration4 = watch("declaration4")
  const declaration5 = watch("declaration5")
  const declaration6 = watch("declaration6")

  useEffect(() => {
    Promise.all([
      // UPS Party Id
      fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER,
        undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'OB_WHITE_LABEL_UPS_PARTY' }],
        undefined,
        'code'
      ),
      fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER,
        undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'OB_WHITE_LABEL_BAND_CHARGE' }],
        undefined,
        'code'
      )
    ]).then(([upsPartyId, bandChargeId]) => {
      const upsPartyIdList = Object.keys(upsPartyId)
      if(upsPartyIdList.length>0){
        setUPSPartyId(upsPartyIdList[0])
      }

      const bandChargeIdList = Object.keys(bandChargeId)
      if(bandChargeIdList.length>0){
        setBandChargeId(bandChargeIdList[0])
      }
    })
  }, []);

  const onSubmit = () => {

    function onSuccess(response) {

      if (response.status == 200) {
        const data = response.data
        if (data.errorMessages != null && data.errorMessages != undefined && data.errorMessages.length > 0) {
          showNotification('error', data.errorMessages)
        } else {
          showNotification('success', translatedTextsObject.successMsg)
        }
      } else {
        showNotification('error', translatedTextsObject.errorMsg)
      }
    }

    function onError(error) {
      console.error('Error', error)
      showNotification('error', translatedTextsObject.errorMsg)
    }

    function onComplete(response) {
      setLoadingState(false)
    }
    const config = {}

    //validate form
    const result = trigger()

    result.then(function (result) {
      if (result == true) {

        if ((parentPartyId !== upsPartyId && parentPartyId !== bandChargeId && getValues("declaration1") == true && getValues("declaration3") == true) ||
          (parentPartyId === upsPartyId && getValues("declaration1") == true && getValues("declaration3") == true && getValues("declaration4") == true) ||
          (parentPartyId === bandChargeId && getValues("declaration5") == true && getValues("declaration6") == true)
        ) {
          setLoadingState(true)
          //submit
          securedSendRequest.execute('POST', OnBoardWhiteLabelPartyApiUrls.CREATE, getValues(), onSuccess, onError, onComplete, config, null);
        } else {
          showNotification('error', translatedTextsObject.checkAllDeclarationErrorMsg)
        }
      }
    })
  }

  const onClear = () => {
    reset();
    setValue("declaration1", false)
    setValue("declaration2", false)
    setValue("declaration3", false)
    setValue("declaration4", false)
    setValue("declaration5", false)
    setValue("declaration6", false)
  }

  function makeTranslatedTextsObject() {
    let onBoardWhiteLabelParty = translate(
      Namespace.ON_BOARD_WHITE_LABEL_PARTY,
      OnBoardWhiteLabelPartyKeys.TITLE
    )

    let partyId = translate(
      Namespace.ON_BOARD_WHITE_LABEL_PARTY,
      OnBoardWhiteLabelPartyKeys.PARTY_ID
    )

    let parentPartyId = translate(
      Namespace.ON_BOARD_WHITE_LABEL_PARTY,
      OnBoardWhiteLabelPartyKeys.PARENT_PARTY_ID
    )

    let declaration1 = translate(
      Namespace.ON_BOARD_WHITE_LABEL_PARTY,
      OnBoardWhiteLabelPartyKeys.DECLARATION_1
    )

    let declaration2 = translate(
      Namespace.ON_BOARD_WHITE_LABEL_PARTY,
      OnBoardWhiteLabelPartyKeys.DECLARATION_2
    )

    let declaration3 = translate(
      Namespace.ON_BOARD_WHITE_LABEL_PARTY,
      OnBoardWhiteLabelPartyKeys.DECLARATION_3
    )

    let declaration4 = translate(
      Namespace.ON_BOARD_WHITE_LABEL_PARTY,
      OnBoardWhiteLabelPartyKeys.DECLARATION_4
    )

    let declaration5 = translate(
      Namespace.ON_BOARD_WHITE_LABEL_PARTY,
      OnBoardWhiteLabelPartyKeys.DECLARATION_5
    )

    let declaration6 = translate(
      Namespace.ON_BOARD_WHITE_LABEL_PARTY,
      OnBoardWhiteLabelPartyKeys.DECLARATION_6
    )

    let requesterName = translate(
      Namespace.ON_BOARD_WHITE_LABEL_PARTY,
      OnBoardWhiteLabelPartyKeys.REQUESTER_NAME
    )

    let selfDeclarationPart1 = translate(
      Namespace.ON_BOARD_WHITE_LABEL_PARTY,
      OnBoardWhiteLabelPartyKeys.SELF_DECLARATION_PART_1
    )

    let selfDeclarationPart2 = translate(
      Namespace.ON_BOARD_WHITE_LABEL_PARTY,
      OnBoardWhiteLabelPartyKeys.SELF_DECLARATION_PART_2
    )

    let submitButton = translate(
      Namespace.ON_BOARD_WHITE_LABEL_PARTY,
      OnBoardWhiteLabelPartyKeys.SUBMIT_BUTTON
    )

    let discardButton = translate(
      Namespace.ON_BOARD_WHITE_LABEL_PARTY,
      OnBoardWhiteLabelPartyKeys.DISCARD_BUTTON
    )

    let successMsg = translate(
      Namespace.ON_BOARD_WHITE_LABEL_PARTY,
      OnBoardWhiteLabelPartyKeys.SUCCESS_MSG
    )

    let errorMsg = translate(
      Namespace.ON_BOARD_WHITE_LABEL_PARTY,
      OnBoardWhiteLabelPartyKeys.ERROR_MSG
    )

    let checkAllDeclarationErrorMsg = translate(
      Namespace.ON_BOARD_WHITE_LABEL_PARTY,
      OnBoardWhiteLabelPartyKeys.CHECK_ALL_DECLARATION_ERROR_MSG
    )

    return {
      onBoardWhiteLabelParty,
      partyId,
      parentPartyId,
      declaration1,
      declaration2,
      declaration3,
      declaration4,
      declaration5,
      declaration6,
      requesterName,
      selfDeclarationPart1,
      selfDeclarationPart2,
      submitButton,
      discardButton,
      successMsg,
      errorMsg,
      checkAllDeclarationErrorMsg
    }
  }
  return (
    <Card>
      <CngSimpleCardHeader title={translatedTextsObject.onBoardWhiteLabelParty} />
      <CngGridItem xs={12} sm={9}>
        <CngBackdrop loading={loadingState} />
      </CngGridItem>
      <CardContent>
        <Grid container spacing={3}>
          <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.partyId}>
            <TprPartyAutoCompleteField
              required
              name='partyId'
              label={translatedTextsObject.partyId}
              lookupProps={{
                label: (record) => `${record.id};${record.name}`
              }}
              size='small'
            />
          </CngGridItem>
          <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.parentPartyId}>
            <CngCodeMasterAutocompleteField
              required
              name='parentPartyId'
              label={translatedTextsObject.parentPartyId}
              lookupProps={{
                label: (record) => `${record.code};${record.descriptionEn}`
              }}
              codeType='OB_WHITE_LABEL_PARENT_PARTY'
              size='small'
            />
          </CngGridItem>
          <CngGridItem xs={12} sm={12} shouldHide={shouldHideMap.declaration1}>
            {parentPartyId && parentPartyId !== bandChargeId &&
            <CheckboxButton
              name='declaration1'
              label={translatedTextsObject.declaration1}
              checked={declaration1 === true}
            />
            }
            {parentPartyId && parentPartyId !== bandChargeId &&
            <CheckboxButton
              name='declaration3'
              label={translatedTextsObject.declaration3}
              checked={declaration3 === true}
            />
            }
            {parentPartyId && parentPartyId === upsPartyId &&
              <CheckboxButton
                name='declaration4'
                label={translatedTextsObject.declaration4}
                checked={declaration4 === true}
              />
            }
            {parentPartyId && parentPartyId === bandChargeId &&
              <CheckboxButton
                name='declaration5'
                label={translatedTextsObject.declaration5}
                checked={declaration5 === true}
              />
            }
            {parentPartyId && parentPartyId === bandChargeId &&
              <CheckboxButton
                name='declaration6'
                label={translatedTextsObject.declaration6}
                checked={declaration6 === true}
              />
            }
          </CngGridItem>
          <CngGridItem xs={12} sm={12} shouldHide={shouldHideMap.requesterName}>
            {translatedTextsObject.selfDeclarationPart1 + "  "}
            <Box sx={{ width: 300, display: 'inline-flex' }}>
              <CngTextField
                required
                name='requesterName'
                label={translatedTextsObject.requesterName}
                disabled={disabled}
                size='small'

              />
            </Box>
            {"  " + translatedTextsObject.selfDeclarationPart2}
          </CngGridItem>
        </Grid>
        <Grid>
          <ButtonComponent
            onSubmit={onSubmit}
            onClear={onClear}
            translatedTextsObject={translatedTextsObject}
          ></ButtonComponent>
        </Grid>
      </CardContent>
    </Card>
  )
}

function toClientDataFormat(serverData) {
  let localData = DataFlattener.parse(serverData);
  return localData;
}

function toServerDataFormat(localData) {
  return DataFlattener.unflatten(localData);
}

const FormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields,
  toClientDataFormat: toClientDataFormat,
  toServerDataFormat: toServerDataFormat
})

export default FormProperties

function ButtonComponent({
  onSubmit,
  onClear,
  translatedTextsObject
}) {

  return (
    <Box pl={5} pr={5} pt={4} pb={4}>
      <Grid container xs={12} sm={12}>
        <Grid container xs={12} sm={12} justify="center">
          <Box pr={2}>
            <Button
              variant="contained"
              className="button-blue originalText"
              onClick={() => {
                onSubmit();
              }}
            >
              {translatedTextsObject.submitButton}
            </Button>
          </Box>
          <Box pr={2}>
            <Button
              variant="contained"
              className="button-blue originalText"
              onClick={() => {
                onClear();
              }}
            >
              {translatedTextsObject.discardButton}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}